"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizeCommentsIntoThreads = organizeCommentsIntoThreads;
exports.fetchComments = fetchComments;
exports.createComment = createComment;
exports.deleteComment = deleteComment;
const client_1 = require("./client");
// ─── Thread organisation (pure) ───────────────────────────────────────────────
/**
 * Converts a flat WP comments array into a recursive tree.
 * Root comments: newest-first. Replies: oldest-first (thread-chronological).
 */
function organizeCommentsIntoThreads(comments) {
    if (!comments.length)
        return [];
    const map = {};
    comments.forEach((c) => { map[c.id] = { ...c, replies: [] }; });
    const roots = [];
    comments.forEach((c) => {
        const node = map[c.id];
        if (!c.parent || c.parent === 0) {
            roots.push(node);
        }
        else {
            const parent = map[c.parent];
            if (parent)
                parent.replies.push(node);
            else
                roots.push(node);
        }
    });
    const sort = (list, desc) => {
        list.sort((a, b) => {
            const da = new Date(a.date_gmt || a.date).getTime();
            const db = new Date(b.date_gmt || b.date).getTime();
            return desc ? db - da : da - db;
        });
        list.forEach((n) => { if (n.replies.length)
            sort(n.replies, false); });
    };
    sort(roots, true);
    return roots;
}
// ─── API helpers (injectable auth) ───────────────────────────────────────────
async function fetchComments(postId, baseUrl, getHeaders = async () => ({})) {
    const headers = await getHeaders();
    const url = `${baseUrl}api/wp/v2/comments?post=${postId}&order=asc&per_page=100`;
    const res = await (0, client_1.fetchWithTimeout)(url, { headers });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : [];
}
async function createComment(postId, content, parentId = 0, baseUrl, getHeaders = async () => ({})) {
    const headers = await getHeaders();
    const body = { post: postId, content };
    if (parentId > 0)
        body.parent = parentId;
    const res = await (0, client_1.fetchWithTimeout)(`${baseUrl}api/wp/v2/comments`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message ?? `HTTP ${res.status}`);
    }
    return res.json();
}
async function deleteComment(commentId, baseUrl, getHeaders = async () => ({})) {
    const headers = await getHeaders();
    const res = await (0, client_1.fetchWithTimeout)(`${baseUrl}api/wp/v2/comments/${commentId}?force=true`, {
        method: 'DELETE',
        headers,
    });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
}
//# sourceMappingURL=comments.js.map